// Webpack Imports
import 'bootstrap';

(function($) {

	// PLACEHOLDER
	$('input,textarea').focus(function () {
	    $(this).data('placeholder', $(this).attr('placeholder'))
	        .attr('placeholder', '');
		}).blur(function () {
	    $(this).attr('placeholder', $(this).data('placeholder'));
	});

	// SEARCH WIDGET 
	$('.search__widget').hide();
	$('.navbar__fixed-search').click(function () {
        $('.search__widget').fadeIn();
    });

	$('.search__widget-close').click(function () {
	    $('.search__widget').fadeOut();
	 });


	// MENU SIZE - SCROLL DOWN
    var menu = $('body').offset().top+200

    $(window).scroll(function() {
        if ( $(this).scrollTop() >= menu ) {
            $('.navbar__fixed').addClass('navbar__fixed--small');
        } else {
           $('.navbar__fixed').removeClass('navbar__fixed--small');
       }
    });

}( jQuery ) );
